const newEventStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    form: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      flexWrap: 'wrap',
      paddingTop: theme.spacing(1.5),
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
    containerRowClass: {
      marginBottom: theme.spacing(1.5),
    },
    inputStyles: {
      minWidth: 140,
      flex: 1,
      paddingLeft: 5,
      paddingRight: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
        fontSize: 10,
      },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b',
      },
    },
    placeHolder: {
      '&::placeholder': {
        color: 'red !important',
        fontSize: 600,
        textAlign: 'left',
      },
    },
    boxSelectContSpec: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      flex: 1,
      paddingLeft: 5,
      paddingRight: 5,
    },

    boxSelectCont: {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
      paddingLeft: 5,
      paddingRight: 5,
    },

    multi: {
      flex: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderWidth: 2,
      borderStyle: 'solid',
      marginBottom: '14px',
    },
    borderStadiumCls: {
      border: '1px solid #e3e3e3',
      borderRadius: 10,
      padding: '14px',
    },
    button: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#008000',
      borderColor: '#008000',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    button1: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#90103B',
      borderColor: '#90103B',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#90103B',
        borderColor: '#00acc1',
      },
    },
    typoHeading: {
      // fontSize: '1rem',
      cursor: 'pointer',
      fontWeight: 500,
    },
    btnContainer: {
      marginTop: '50px',
      marginBottom: '2rem',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    attachIconStyle: {
      fontSize: '1rem',
      color: '#0000003b',
      cursor: 'pointer',
    },
    calendarIconStyle: {
      fontSize: '1rem',
      cursor: 'pointer',
      padding: 0,
    },
    choseTextClass: {
      cursor: 'pointer',
    },
    errorCls: {
      color: 'red',
      fontSize: 10,
      position: 'absolute',
      left: 0,
      bottom: '-15px',
      paddingLeft: 5,
    },
    positionCls: {
      position: 'relative',
    },
    imageIcon: {
      maxHeight: 140,
      width: theme.spacing(12),
      height: theme.spacing(12),
      objectFit: 'cover',
      overflow: 'hidden',
      borderRadius: theme.spacing(0.5),
    },
    imageLayout: {
      // maxHeight: 140,
      width: '200px',
      // height: theme.spacing(12),
      objectFit: 'cover',
      overflow: 'hidden',
      borderRadius: theme.spacing(0.5),
    },
    icon: {
      fill: '#fff',
    },
    btnOkCls: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0.8),
      paddingRight: theme.spacing(0.8),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      // borderColor: '#008000',
      // backgroundColor: '#008000',
      borderColor: '#90103B',
      backgroundColor: '#90103B',
      // minWidth: theme.spacing(14),
      '&:hover': {
        backgroundColor: '#90103B',
        borderColor: '#00acc1',
      },
    },
    arrowIconCls: {
      padding: 0,
      marginRight: 0,
      height: 15,
      width: 15,
    },
  };
};

export default newEventStyles;
